
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../Reducers/rootReducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Disable serializable check for better performance
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredPaths: ['_persist'],
      },
      // Disable immutable check for better performance
      immutableCheck: {
        ignoredPaths: ['marketData.RawMarketData', 'trades.trades'],
      },
    }),
  // Enable Redux DevTools in development
  devTools: process.env.NODE_ENV !== 'production',
});
